import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArFulfillmentEventsPublishedNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArFulfillmentEventsPublishedNotifyFollowers: TemplateDefinition<ArFulfillmentEventsPublishedNotifyFollowersProps> =
  {
    renderParams: (props: ArFulfillmentEventsPublishedNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arFulfillmentEventsPublishedNotifyFollowers',
      values: {
        eventName: props?.request?.name,
      },
    }),
  }
